module.exports = __webpack_public_path__ + "static/img/cygn3.31b64c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn3.png
// module id = 312
// module chunks = 0